// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__-XK8Q","menu__roomContainer":"menu_menu__roomContainer__OC79S","menu__room":"menu_menu__room__33L+f","menu__chat":"menu_menu__chat__6m1L5"};